import { Point } from "../../models";

export const tableCardsContainerPosition: Point = { x: 0, y: 0 };

export const communityCardPositions: Point[] = [
  { x: 722, y: 407 },
  { x: 819.3, y: 407 },
  { x: 916.6, y: 407 }, // center card, centered on the table/canvas midpoint (960)
  { x: 1013.9, y: 407 },
  { x: 1111.2, y: 407 },
];
export const communityCardScale: Point = { x: 1.0337, y: 0.8598 };
export const r2tT1Positions: Point[] = [
  { x: 743.7, y: 334.2 },
  { x: 832.6, y: 334.2 },
  { x: 920.9, y: 334.2 },
  { x: 1009.2, y: 334.2 },
  { x: 1098.1, y: 334.2 },
];
export const r2tT2Positions: Point[] = [
  { x: 722, y: 444 },
  { x: 819.3, y: 444 },
  { x: 916.6, y: 444 },
  { x: 1013.9, y: 444 },
  { x: 1111.2, y: 444 },
];
export const r2tT1Scale: Point = { x: 0.9325, y: 0.7756 };
export const r2tT2Scale: Point = { x: 1.0337, y: 0.8598 };
// Shared R2T cards stay exactly where the single board put them
export const r2tSharedPositions: Point[] = communityCardPositions.slice(0, 4);
export const r2tSharedScale: Point = communityCardScale;
export const r2tPartialScale: Point = { x: 0.951, y: 0.791 };
export const r2tPartialLayouts: { [sharedCards: number]: { t1: Point[]; t2: Point[] } } = {
  3: {
    t1: [{ x: 1009.7, y: 359.8 }, { x: 1096.0, y: 359.8 }],
    t2: [{ x: 1017.4, y: 462.5 }, { x: 1110.9, y: 462.5 }],
  },
  4: {
    t1: [{ x: 1103.1, y: 359.8 }],
    t2: [{ x: 1118.1, y: 462.5 }],
  },
};
export const communityCardEdgeTilt: number[] = [0.1902, 0.0977, 0.0524, -0.0524, -0.0977, -0.1902];
